module.exports = __webpack_public_path__ + "static/lycee-logo-ff986e56ffe8a147a9cc1d517072007c.png";